import { forwardRef } from "react";
import clsx from "clsx";

// MUI
import { Typography } from "@mui/material";

interface INotificationSpan {
	str: string;
	clamped?: boolean;
}

export const NotificationSpan = forwardRef<HTMLSpanElement, INotificationSpan>((props, ref) => {
	const { str, clamped = false } = props;
	return (
		<Typography
			ref={ref}
			variant={"body1"}
			className={clsx({
				"!font-sans !text-[14.5px]/[1.3em] [&_a]:no-underline [&_a]:text-ellipsis [&_a]:font-semibold [&_a]:text-primary !text-default":
					true,
				"!line-clamp-2": clamped,
				// custom styles for the notification when they are OEM feedback
				"[&_span.oem-feedback_ul_li]:before:content-['—']": true, // it is not a dash, it is a long hyphen
				"[&_span.oem-feedback_ul_li]:before:mr-[4px]": true,
				"[&_span.oem-feedback_ul_li]:ml-[4px]": true,
			})}
			dangerouslySetInnerHTML={{ __html: str }}
		/>
	);
});
